<script setup>
import {computed} from "vue";
import moment from "moment";

const props = defineProps({
  customer: {
    type: Object,
    required: true,
  },
  totalCustomers: {
    type: Number,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  }
});

const createdAt = computed(() => props.customer.createdAt ? moment(props.customer.createdAt).format('Do MMM YYYY') : '-')

</script>

<template>
  <div
    class="tw-grid tw-grid-cols-10 tw-h-24 tw-overflow-hidden tw-border-grey-light"
    :class="{
      'tw-border-b': index !== totalCustomers - 1,
    }"
  >
    <div class="tw-col-span-2 tw-px-4 tw-my-auto">
      {{ customer.name }}
    </div>

    <div class="tw-col-span-2 tw-px-4 tw-my-auto">
      <a
        :href="`mailto: ${customer.email}`"
        class="tw-text-blue"
      >{{ customer.email }}</a>
    </div>

    <div class="tw-col-span-2 tw-px-4 tw-my-auto">
      <a
        v-if="customer.url"
        :href="customer.url"
        class="tw-text-blue"
      >{{ customer.url }}</a>
    </div>

    <div class="tw-col-span-2 tw-px-4 tw-my-auto">
      <a
        v-if="customer.stripeId"
        target="_blank"
        class="tw-text-blue"
        :href="`https://dashboard.stripe.com/customers/${customer.stripeId}`"
      >{{ customer.stripeId }}</a>
    </div>

    <div class="tw-col-span-2 tw-px-4 tw-my-auto">
      {{ createdAt }}
    </div>
  </div>
</template>